"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, CircularProgress, circularProgressClasses } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { ColorVariant } from "../../theme";
import { progressColor } from "./types";
const CustomCircularProgress = ({
  color,
  typeButton = true,
  ...props
}) => {
  return <StyledBox $typeButton={typeButton}>
      <CircularProgress variant="determinate" sx={{
      color: ColorVariant.GRAYSCALE_200
    }} size={typeButton ? 25 : 40} thickness={5} {...props} value={100} />
      <CircularProgress variant="indeterminate" disableShrink sx={{
      animationDuration: "800ms",
      position: "absolute",
      left: 0,
      color: ColorVariant[color],
      [`& .${circularProgressClasses.circle}`]: {
        strokeLinecap: "round"
      }
    }} size={typeButton ? 25 : 40} thickness={5} {...props} />
    </StyledBox>;
};
const Progress = t0 => {
  const $ = _c(3);
  const {
    color: t1,
    typeButton
  } = t0;
  const color = t1 === undefined ? progressColor.PRIMARY_500 : t1;
  let t2;
  if ($[0] !== color || $[1] !== typeButton) {
    t2 = <CustomCircularProgress color={color} typeButton={typeButton} />;
    $[0] = color;
    $[1] = typeButton;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const StyledBox = styled(Box)`
  position: relative;
  ${({
  $typeButton
}) => $typeButton && `
    width: 25px;
    height: 25px;
  `};
  }
`;
export default Progress;